import { render, staticRenderFns } from "./LmsStudentClasses.vue?vue&type=template&id=53c26141&scoped=true"
import script from "./LmsStudentClasses.vue?vue&type=script&lang=js"
export * from "./LmsStudentClasses.vue?vue&type=script&lang=js"
import style0 from "./LmsStudentClasses.vue?vue&type=style&index=0&id=53c26141&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c26141",
  null
  
)

export default component.exports